(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('Signup', Signup);

    Signup.$inject = ['$resource'];

    function Signup($resource) {
        var resourceUrl = 'api/invitations';

        return $resource(resourceUrl, {}, {
            'getInvitation': {method : 'GET'},
            'registerNewUser' : {
                method : 'POST',
                url : 'api/invitations/signup'
            }
        });
    }
})();
